import { useQuery } from "@tanstack/react-query";
import { EXCLUDE_VEHICLE_CATEGORIES_SFA_PLUS } from "../../../modules/calculator/calcs/vehicle/utils";
import { vehicleAutocompleteApi } from "../../../modules/vehicle/autocomplete/api";
import { VehicleAutocompleteRequest } from "../../../modules/vehicle/autocomplete/types";

export const VEHICLE_AUTOCOMPLETE_QUERY_KEYS = {
  getVehiclesAutocomplete: (payload: VehicleAutocompleteRequest) => ["getVehiclesAutocomplete", payload],
};

export const useGetVehiclesAutocomplete = (payload: VehicleAutocompleteRequest, isSFAPlus: boolean = false) => {
  return useQuery({
    queryKey: VEHICLE_AUTOCOMPLETE_QUERY_KEYS.getVehiclesAutocomplete(payload),
    meta: { globalSpinner: false },
    queryFn: async () => {
      const { data } = await vehicleAutocompleteApi.autocompleteVehicles(payload);
      return data;
    },
    select: (data) => ({
      ...data,
      data: data.data.filter(
        (vehicle) => !isSFAPlus || !EXCLUDE_VEHICLE_CATEGORIES_SFA_PLUS.includes(vehicle.category),
      ),
    }),
    enabled: !!payload.keyword && payload.keyword.length >= 6,
  });
};
